export interface EventMatchParams {
  eventId: string;
}

export enum ViewerQueryParam {
  Token = "token",
}
